import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

interface ProfileIconProps {
  sx?: SxProps<Theme>;
  /** Stroke colour; defaults to the surrounding text colour. */
  color?: string;
}

/**
 * Inline line icons traced from the My Profile design. Sizes and colours are
 * supplied by the caller from `MyProfile.styles.ts` so no design value is
 * baked in here.
 */
const StrokeIcon: React.FC<
  ProfileIconProps & { strokeWidth?: number; children: React.ReactNode }
> = ({ sx, color, strokeWidth = 2, children }) => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ?? "currentColor"}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={sx}
  >
    {children}
  </Box>
);

/** Shield with a tick — sits inside the "Admin" role chip. */
export const RoleShieldIcon: React.FC<ProfileIconProps> = (props) => (
  <StrokeIcon {...props}>
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
    <path d="M9 12l2 2 4-4" />
  </StrokeIcon>
);

/** Pencil in the round button on a filled signature / initials tile. */
export const SignatureEditIcon: React.FC<ProfileIconProps> = (props) => (
  <StrokeIcon {...props}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
  </StrokeIcon>
);
